import React, {
  createContext, FC, useContext, useReducer,
} from 'react';
import { ActionFromPayloadMap, Layer } from '../config/types';
import LayerReducer from '../reducers/layers';

export type LayerStateType = {
  layersKeyedById: Map<string, Layer>
  isFetchingLayers: boolean
  lastFetchStartTime: Date | null
};

export type LayerActionPayloadMap = {
  SET_LAYERS: Map<string, Layer>;
  SET_FETCHING_LAYERS: boolean;
  SET_LAST_FETCH_START_TIME: Date;
};

export type LayerAction = ActionFromPayloadMap<LayerActionPayloadMap>;

const initialState: LayerStateType = {
  layersKeyedById: new Map(),
  isFetchingLayers: false,
  lastFetchStartTime: null,
};

export const LayerContext = createContext({
  state: initialState,
  dispatch: (() => { }) as React.Dispatch<LayerAction>,
});

export const useLayer = (): [LayerStateType, React.Dispatch<LayerAction>] => {
  const { state, dispatch } = useContext(LayerContext);
  return [state, dispatch];
};

export const LayerProvider:FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [state, dispatch] = useReducer(LayerReducer, initialState);

  return (
    <LayerContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </LayerContext.Provider>
  );
};
